import { Component, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TabsModule } from 'primeng/tabs';
import { UserService } from "../../../layout/service/user.service";
import { ButtonModule } from "primeng/button";
import { DialogModule } from "primeng/dialog";
import { InputTextModule } from "primeng/inputtext";
import { TextareaModule } from "primeng/textarea";
import { FormsModule } from "@angular/forms";
import { ConfirmationService, MessageService } from "primeng/api";
import { ToastModule } from "primeng/toast";
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { SelectModule } from 'primeng/select';
import { JsonParsePipe } from './json-parse.pipe';
import { AutoFocusModule } from 'primeng/autofocus';
import { EditorModule } from 'primeng/editor';
import { CheckboxModule } from 'primeng/checkbox';
import { FileUploadModule } from 'primeng/fileupload';

@Component({
    selector: "app-sheet-cases",
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        TabsModule,
        ButtonModule,
        DialogModule,
        InputTextModule,
        TextareaModule,
        ToastModule,
        ToggleSwitchModule,
        ConfirmDialogModule,
        SelectModule,
        JsonParsePipe,
        AutoFocusModule,
        EditorModule,
        CheckboxModule,
        FileUploadModule
    ],
    providers: [MessageService, ConfirmationService],
    template: `
        <p-toast />
        <p-confirmDialog />
        <p-dialog header="{{ editMode ? 'Edit Kasus' : 'Tambah Kasus' }}" [modal]="true" [(visible)]="dialogCases" [style]="{ width: '50rem' }">
            <div class="flex flex-col gap-4 mb-4">
                <label for="judul" class="font-semibold w-24">Judul</label>
                <input pInputText id="judul" class="w-full" autocomplete="off" [(ngModel)]="judul" />
            </div>
            <div class="flex flex-col gap-4 mb-4">
                <label for="decription" class="font-semibold w-24">Deskripsi</label>
                <p-editor rows="5" cols="30" pTextarea [(ngModel)]="decription"></p-editor>
            </div>
            <div class="flex flex-col gap-4 mb-4">
                <label for="durasi" class="font-semibold w-24">Durasi</label>
                <input pInputText id="durasi" class="w-full" autocomplete="off" [(ngModel)]="durasi" />
            </div>
            <div class="flex flex-col gap-4 mb-4">
                <label class="font-semibold w-24">Status Aktif</label>
                <p-toggleSwitch [(ngModel)]="is_active" onLabel="Aktif" offLabel="Nonaktif"></p-toggleSwitch>
            </div>
            <div class="flex justify-end gap-2">
                <p-button label="Cancel" severity="secondary" (click)="closeDialogCases()" />
                <p-button label="Save" severity="primary" (click)="editMode ? updateCases() : saveCases()" />
            </div>
        </p-dialog>
        <p-dialog header="Tambah Pemeriksaan" [modal]="true" [(visible)]="dialogPemeriksaan" [style]="{ width: '50rem' }">
            <div class="flex flex-col gap-4 mb-4">
                <label for="pemeriksaan" class="font-semibold">Pemeriksaan</label>
                <input pInputText id="pemeriksaan" class="w-full" autocomplete="off" [(ngModel)]="pemeriksaanText" />
            </div>
            <div class="flex flex-col gap-4 mb-4">
                <label for="type" class="font-semibold">Type</label>
                <p-select
                    id="type"
                    class="w-full"
                    [options]="typeOptions"
                    optionLabel="label"
                    optionValue="value"
                    [(ngModel)]="pemeriksaanType"
                    placeholder="Pilih Type"
                    appendTo="body"
                ></p-select>
            </div>
            <ng-container *ngIf="pemeriksaanType === 'table'">
                <div class="flex flex-col gap-2 mb-2">
                    <label class="font-semibold">Header Tabel</label>
                    <ng-container *ngFor="let header of tableHeaders; let i = index">
                        <div class="flex flex-col md:flex-row gap-2 mb-2 items-center">
                            <label class="font-semibold min-w-[90px]">Header {{ i + 1 }}</label>
                            <input pInputText class="flex-1 w-full" [pAutoFocus]="true" [(ngModel)]="tableHeaders[i]" placeholder="Header" />
                            <button pButton type="button" icon="pi pi-trash" class="p-button-sm p-button-danger" (click)="removeHeader(i)"></button>
                        </div>
                    </ng-container>
                    <div class="flex flex-col md:flex-row gap-2 items-center">
                        <label class="font-semibold min-w-[90px]">Header {{ tableHeaders.length + 1 }}</label>
                        <input pInputText class="flex-1 w-full"
                            [(ngModel)]="newHeader"
                            name="newHeader"
                            autocomplete="off"
                            [pAutoFocus]="true"
                            placeholder="Tambah Header Baru"
                            (keyup.enter)="addHeader()"
                        />
                        <button pButton type="button" icon="pi pi-plus" class="p-button-sm" (click)="addHeader()"></button>
                    </div>
                </div>
                <!-- Preview Table -->
                <div class="overflow-x-auto mt-4">
                    <table class="min-w-full border border-gray-300 rounded">
                        <thead>
                            <tr>
                                <th *ngFor="let header of tableHeaders" class="px-4 py-2 bg-gray-100 border-b text-left font-semibold text-sm text-gray-700">
                                    {{ header || '-' }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td *ngFor="let header of tableHeaders" class="px-4 py-2 border-b text-gray-500">
                                    Dummy Data
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </ng-container>
            <div class="flex justify-end gap-2 mt-4">
                <p-button label="Cancel" severity="secondary" (click)="closeDialogPemeriksaan()" />
                <p-button label="Save" severity="primary" (click)="savePemeriksaan()" />
            </div>
        </p-dialog>
        <p-dialog header="Pilih OSCE untuk Detail Pemeriksaan" [modal]="true" [(visible)]="dialogOsce" [style]="{ width: '40rem' }">
            <div class="flex flex-col gap-4 mb-4">
                <label for="osce" class="font-semibold">Pilih OSCE</label>
                <p-select
                    id="osce"
                    class="w-full"
                    [options]="osceList"
                    optionLabel="TITLE"
                    optionValue="ID_OSCE"
                    [(ngModel)]="selectedOsceId"
                    placeholder="Pilih OSCE"
                    appendTo="body"
                    [filter]="true"
                    filterBy="TITLE"
                    [showClear]="true"
                ></p-select>
            </div>
            <div class="flex justify-end gap-2">
                <p-button label="Cancel" severity="secondary" (click)="closeDialogOsce()" />
                <p-button label="Tambahkan" severity="success" (click)="addPemeriksaanToOsce()" [disabled]="!selectedOsceId" />
            </div>
        </p-dialog>

        <!-- Dialog untuk memilih pemeriksaan yang sudah ada untuk detail -->
        <p-dialog header="Pilih Pemeriksaan untuk Detail" [modal]="true" [(visible)]="dialogSelectPemeriksaan" [style]="{ width: '50rem' }">
            <div class="flex flex-col gap-4 mb-4">
                <label for="selectPemeriksaan" class="font-semibold">Pilih Pemeriksaan</label>
                <p-select
                    id="selectPemeriksaan"
                    class="w-full"
                    [options]="filteredPemeriksaan"
                    optionLabel="name"
                    optionValue="id"
                    [(ngModel)]="selectedPemeriksaanIdForDetail"
                    placeholder="Pilih Pemeriksaan"
                    appendTo="body"
                    [filter]="true"
                    filterBy="name"
                    [showClear]="true"
                ></p-select>
            </div>
            <div class="flex justify-end gap-2">
                <p-button label="Cancel" severity="secondary" (click)="closeDialogSelectPemeriksaan()" />
                <p-button label="Pilih" severity="success" (click)="selectPemeriksaanForDetail()" [disabled]="!selectedPemeriksaanIdForDetail" />
            </div>
        </p-dialog>
        <div class="card">
            <p-tabs value="0">
                <p-tablist>
                    <p-tab value="0">Kasus</p-tab>
                    <p-tab value="1">Pemeriksaan</p-tab>
                    <p-tab value="2">Detail Pemeriksaan</p-tab>
                </p-tablist>
                <p-tabpanels>
                    <p-tabpanel value="0">
                        <div class="flex flex-col md:flex-row md:items-center md:justify-between mb-3 gap-2">
                            <h3 class="m-0 font-bold text-lg text-gray-800">Kasus</h3>
                            <div class="flex flex-1 gap-2 justify-end items-center">
                                <input
                                    pInputText
                                    type="text"
                                    placeholder="Cari judul atau deskripsi kasus..."
                                    class="w-full md:w-72 p-2 border rounded focus:outline-none focus:ring-2 focus:ring-primary-500"
                                    [(ngModel)]="searchText"
                                    (ngModelChange)="applySearchSort()"
                                />
                                <p-button icon="pi pi-plus" label="Tambah Kasus" (click)="openDialogCases()" />
                            </div>
                        </div>
                        <div class="flex flex-col gap-4">
                            <ng-container *ngIf="filteredCases.length > 0; else notFound">
                                <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                                    <ng-container *ngFor="let item of filteredCases">
                                        <div class="p-4 rounded-lg shadow bg-white border border-gray-100 hover:shadow-lg transition-all duration-200 flex flex-col justify-between h-full">
                                            <div>
                                                <div class="flex items-center justify-between mb-2">
                                                    <span class="text-lg font-semibold text-gray-800 truncate block" [title]="item.name">{{ item.name }}</span>
                                                    <span *ngIf="item.is_active == 1" class="inline-block bg-green-100 text-green-800 text-xs px-2 py-1 rounded font-semibold ml-2">
                                                        Aktif
                                                    </span>
                                                    <span *ngIf="item.is_active != 1" class="inline-block bg-red-200 text-red-600 text-xs px-2 py-1 rounded font-semibold ml-2">
                                                        Nonaktif
                                                    </span>
                                                </div>
                                                <div class="mb-3 text-gray-600 min-h-[48px] max-h-[300px] overflow-y-auto break-words" [innerHTML]="item.description || 'Tidak ada deskripsi'">
                                                </div>
                                            </div>
                                            <div>
                                                <div class="mb-2 flex flex-wrap gap-2">
                                                    <span class="inline-block bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-md font-medium">
                                                        Durasi: {{ item.timer }} menit
                                                    </span>
                                                    <span class="inline-block bg-green-100 text-green-800 text-xs px-2 py-1 rounded-md font-medium">
                                                        Dibuat: {{ item.created_at | date:'dd MMM yyyy' }}
                                                    </span>
                                                </div>
                                                <div class="flex justify-end gap-2 mt-2">
                                                    <button pButton type="button" icon="pi pi-exclamation-triangle" class="p-button-sm p-button-warn" (click)="showSheetDetailMapping(item)" aria-label="Detail"></button>
                                                    <button pButton type="button" icon="pi pi-list" class="p-button-sm p-button-success" (click)="showSheetDetail(item)" aria-label="Detail"></button>
                                                    <button pButton type="button" icon="pi pi-pencil" class="p-button-sm" (click)="editCase(item)" aria-label="Edit"></button>
                                                    <button pButton type="button" icon="pi pi-trash" class="p-button-sm p-button-danger" (click)="deleteCase(item)" aria-label="Hapus"></button>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                            </ng-container>
                            <ng-template #notFound>
                                <div class="flex flex-col items-center justify-center py-12 text-center text-gray-500">
                                    <i class="pi pi-search text-4xl mb-2"></i>
                                    <span class="text-base font-medium">Tidak ada kasus ditemukan.</span>
                                    <span class="text-sm">Coba kata kunci lain atau tambah kasus baru.</span>
                                </div>
                            </ng-template>
                        </div>
                    </p-tabpanel>
                    <p-tabpanel value="1">
                        <div class="flex flex-col md:flex-row md:items-center md:justify-between mb-3 gap-2">
                            <h3 class="m-0 font-bold text-lg text-gray-800">Pemeriksaan</h3>
                            <div class="flex flex-1 gap-2 justify-end items-center">
                                <input
                                    pInputText
                                    type="text"
                                    placeholder="Cari nama pemeriksaan..."
                                    class="w-full md:w-72 p-2 border rounded focus:outline-none focus:ring-2 focus:ring-primary-500"
                                    [(ngModel)]="searchPemeriksaan"
                                    (ngModelChange)="applySearchPemeriksaan()"
                                />
                                <p-button icon="pi pi-plus" label="Tambah Pemeriksaan" (click)="openDialogPemeriksaan()" />
                            </div>
                        </div>
                        <div class="flex flex-col gap-4">
                            <ng-container *ngIf="filteredPemeriksaan && filteredPemeriksaan.length > 0; else notFoundPemeriksaan">
                                <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                                    <ng-container *ngFor="let item of filteredPemeriksaan">
                                        <div class="p-5 rounded-xl shadow-lg bg-white border border-gray-100 hover:shadow-xl transition-all duration-200 flex flex-col h-full">
                                            <div class="flex items-center justify-between mb-2">
                                                <span class="text-lg font-bold text-gray-800 truncate block" [title]="item.name">{{ item.name }}</span>
                                                <span *ngIf="item.is_active == 1" class="inline-block bg-green-100 text-green-800 text-xs px-2 py-1 rounded font-semibold ml-2">
                                                    Aktif
                                                </span>
                                                <span *ngIf="item.is_active != 1" class="inline-block bg-red-200 text-red-600 text-xs px-2 py-1 rounded font-semibold ml-2">
                                                    Nonaktif
                                                </span>
                                            </div>
                                            <div class="mb-2">
                                                <span class="inline-block bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-md font-medium mr-2">
                                                    Type: {{ item.type === 'table' ? 'Tabel' : 'Teks Bebas' }}
                                                </span>
                                                <span class="inline-block bg-green-100 text-green-800 text-xs px-2 py-1 rounded-md font-medium">
                                                    Dibuat: {{ item.created_at | date:'dd MMM yyyy' }}
                                                </span>
                                            </div>
                                            <div *ngIf="item.type === 'table' && item.header" class="mt-2">
                                                <div class="overflow-x-auto">
                                                    <table class="min-w-full border border-gray-200 rounded">
                                                        <thead>
                                                            <tr>
                                                                <th *ngFor="let h of (item.header | jsonParse)" class="px-3 py-2 bg-gray-100 border-b text-left font-semibold text-xs text-gray-700">
                                                                    {{ h }}
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td *ngFor="let h of (item.header | jsonParse)" class="px-3 py-2 border-b text-gray-400">
                                                                    ...
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            <div *ngIf="item.type !== 'table'" class="mt-2 text-gray-500 italic">
                                                <span>Teks Bebas</span>
                                            </div>
                                            <!-- Buttons always at the bottom of the card -->
                                            <div class="flex justify-end gap-2 mt-auto pt-4">
                                                <button pButton type="button" icon="pi pi-pencil" class="p-button-sm" (click)="editPemeriksaan(item)" aria-label="Edit"></button>
                                                <button pButton type="button" icon="pi pi-trash" class="p-button-sm p-button-danger" (click)="deletePemeriksaan(item)" aria-label="Hapus"></button>
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                            </ng-container>
                            <ng-template #notFoundPemeriksaan>
                                <div class="flex flex-col items-center justify-center py-12 text-center text-gray-500">
                                    <i class="pi pi-search text-4xl mb-2"></i>
                                    <span class="text-base font-medium">Tidak ada pemeriksaan ditemukan.</span>
                                    <span class="text-sm">Coba kata kunci lain atau tambah pemeriksaan baru.</span>
                                </div>
                            </ng-template>
                        </div>
                    </p-tabpanel>
                    <p-tabpanel value="2">
    <div class="flex flex-col gap-6">
        <div class="bg-gradient-to-r from-blue-50 to-blue-100 rounded-xl p-6 shadow border border-blue-200">
            <h3 class="font-bold text-xl text-blue-900 mb-4 flex items-center gap-2">
                <i class="pi pi-search text-blue-700"></i>
                Detail Pemeriksaan
            </h3>
            <div class="flex flex-col md:flex-row gap-4 items-center mb-2">
                <p-button label="Tambah Detail Pemeriksaan" icon="pi pi-plus" (click)="openDialogSelectPemeriksaan()" styleClass="p-button-info" />
                <p-fileUpload mode="basic" chooseLabel="Upload File" accept=".xlsx,.xls,.csv,.pdf,.doc,.docx" (onSelect)="onFileSelected($event)" styleClass="p-button-secondary" />
            </div>
            <!-- Daftar Detail Pemeriksaan - Tampil langsung tanpa perlu klik tombol -->
            <!-- Dikelompokkan berdasarkan: 1) Pemeriksaan (LABORATORIUM, RADIOLOGI, dll) 2) OSCE -->
            <div class="mt-6">
                <div class="font-bold text-blue-900 mb-2 flex items-center gap-2">
                    Daftar Detail Pemeriksaan
                </div>
                <!-- Search input for sheet details -->
                <div class="mb-4">
                    <input
                        pInputText
                        type="text"
                        placeholder="Cari detail pemeriksaan..."
                        class="w-full md:w-72 p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                        [(ngModel)]="searchSheetDetailsList"
                        (ngModelChange)="applySearchSheetDetailsList()"
                    />
                </div>
                <div class="grid grid-cols-1 gap-6">
                    <!-- Grup berdasarkan sheet_name, lalu name, lalu osce_name -->
                    <ng-container *ngIf="getSheetNameGroupKeys().length > 0; else noSheetDetails">
                        <ng-container *ngFor="let sheetName of getSheetNameGroupKeys()">
                            <div *ngIf="filteredGroupedSheetDetailsBySheetName[sheetName]?.length > 0" class="bg-green-50 rounded-lg p-4 border border-green-200">
                                <div class="font-bold text-green-800 mb-3 flex items-center gap-2 text-lg">
                                    <i class="pi pi-file text-green-600"></i>
                                    {{ sheetName || 'Sheet Lain' }}
                                    <span class="text-sm bg-green-100 text-green-700 px-2 py-1 rounded font-medium">
                                        {{ filteredGroupedSheetDetailsBySheetName[sheetName]?.length || 0 }} item
                                    </span>
                                </div>
                                <!-- Group items by name within each sheet_name -->
                                <ng-container *ngFor="let detailName of getDetailNameGroupKeysForSheet(sheetName)">
                                    <div *ngIf="getDetailsBySheetNameAndDetailName(sheetName, detailName)?.length > 0" class="mb-4">
                                        <div class="font-semibold text-blue-700 mb-2 flex items-center gap-2">
                                            <i class="pi pi-folder text-blue-600"></i>
                                            {{ detailName || 'Nama Tidak Ada' }}
                                            <span class="text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded font-medium">
                                                {{ getDetailsBySheetNameAndDetailName(sheetName, detailName)?.length || 0 }} item
                                            </span>
                                        </div>
                                        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                                            <div *ngFor="let detail of getDetailsBySheetNameAndDetailName(sheetName, detailName)" class="border border-blue-200 rounded-lg p-4 bg-blue-50 shadow flex flex-col gap-2">
                                                <div class="flex items-center gap-2">
                                                    <img *ngIf="detail.icon" [src]="detail.icon" class="w-8 h-8 rounded" alt="Icon" />
                                                    <span class="font-semibold text-blue-800">{{ detail.osce_name || '-' }}</span>
                                                    <span class="text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded font-medium">
                                                        {{ detail.sheet_type === 'table' ? 'Tabel' : 'Teks Bebas' }}
                                                    </span>
                                                </div>
                                                <div class="text-xs text-gray-500">{{ detail.name }}</div>
                                                <div class="flex gap-2 mt-2">
                                                    <p-button label="Update" icon="pi pi-pencil" (click)="onUpdateSheetDetail(detail)" styleClass="p-button-sm p-button-info" />
                                                    <p-button label="Delete" icon="pi pi-trash" (click)="onDeleteSheetDetail(detail)" styleClass="p-button-sm p-button-danger" />
                                                    <p-button label="OSCE" icon="pi pi-plus" (click)="openOsceDialog(detail)" styleClass="p-button-sm p-button-success" />
                                                </div>
                                                <div class="mt-2">
                                                    <p-fileUpload mode="basic" chooseLabel="Upload Icon" accept=".jpg,.jpeg,.png" (onSelect)="onFileSelectedForDetail($event, detail)" styleClass="p-button-sm p-button-secondary w-full" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </ng-container>
                    </ng-container>
                    <ng-template #noSheetDetails>
                        <div class="flex flex-col items-center justify-center py-12 text-center text-gray-500">
                            <i class="pi pi-search text-4xl mb-2"></i>
                            <span class="text-base font-medium">Tidak ada detail pemeriksaan ditemukan.</span>
                            <span class="text-sm">Coba kata kunci lain atau tambah detail pemeriksaan baru.</span>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>
        <div *ngIf="selectedPemeriksaanDetail" class="rounded-xl shadow-lg border border-blue-200 bg-white p-6 transition-all" data-form="detail-pemeriksaan">
            <div class="flex flex-col md:flex-row md:items-center md:justify-between mb-4 gap-2">
                <div>
                    <div class="text-lg font-bold text-blue-900 mb-1 flex items-center gap-2">
                        <i class="pi pi-file"></i>
                        {{ selectedPemeriksaanDetail.name }}
                    </div>
                    <div class="flex flex-wrap gap-2 mb-1">
                        <span class="inline-block bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-md font-medium">
                            Type: {{ selectedPemeriksaanDetail.type === 'table' ? 'Tabel' : 'Teks Bebas' }}
                        </span>
                    </div>
                </div>
            </div>
            <!-- Table type -->
            <ng-container *ngIf="selectedPemeriksaanDetail.type === 'table' && selectedPemeriksaanDetail.header">
                <div class="mt-4 mb-4">
                    <label class="font-semibold block mb-2 text-blue-800">Judul Pemeriksaan Penunjang</label>
                    <div class="flex gap-2">
                        <p-select
                            class="w-1/2"
                            [options]="getExistingDetailNames()"
                            optionLabel="label"
                            optionValue="value"
                            [(ngModel)]="judulPemeriksaanPenunjang"
                            placeholder="Pilih nama yang sudah ada"
                            appendTo="body"
                            [showClear]="true"
                        ></p-select>
                        <input
                            pInputText
                            class="w-1/2 border border-blue-200 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-300"
                            [(ngModel)]="judulPemeriksaanPenunjang"
                            placeholder="Atau masukkan nama baru"
                        />
                    </div>
                </div>
                <div class="mt-4 mb-4">
                    <label class="font-semibold block mb-2 text-blue-800">Pilih OSCE untuk Detail Pemeriksaan</label>
                    <p-select
                        class="w-full"
                        [options]="osceList"
                        optionLabel="TITLE"
                        optionValue="ID_OSCE"
                        [(ngModel)]="selectedOsceForDetail"
                        placeholder="Pilih OSCE"
                        appendTo="body"
                        [filter]="true"
                        filterBy="TITLE"
                        [showClear]="true"
                        styleClass="border-blue-200"
                    ></p-select>
                </div>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
                    <div *ngFor="let h of (selectedPemeriksaanDetail.header | jsonParse); let i = index" class="bg-blue-50 rounded-lg p-4 border border-blue-100 shadow-sm">
                        <label class="font-semibold block mb-2 text-blue-800">{{ h }}</label>
                        <p-editor [(ngModel)]="tableDetailEditors[i]" [style]="{height:'120px'}" styleClass="rounded border-blue-200"></p-editor>
                    </div>
                </div>
                <!-- Preview Table -->
                <div class="overflow-x-auto mt-8">
                    <div class="font-semibold mb-2 text-blue-800">Preview Tabel Input</div>
                    <table class="min-w-full border border-blue-200 rounded shadow">
                        <thead>
                            <tr>
                                <th *ngFor="let h of (selectedPemeriksaanDetail.header | jsonParse)" class="px-4 py-2 bg-blue-100 border-b text-left font-semibold text-sm text-blue-900">
                                    {{ h || '-' }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td *ngFor="let i of (selectedPemeriksaanDetail.header | jsonParse); let idx = index" class="px-4 py-2 border-b text-gray-700">
                                    <div [innerHTML]="tableDetailEditors[idx]"></div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="flex justify-end mt-4">
                    <p-button label="Simpan" icon="pi pi-save" (click)="saveTableDetail()" styleClass="p-button-success" />
                </div>
            </ng-container>
            <!-- Text type -->
            <ng-container *ngIf="selectedPemeriksaanDetail.type === 'text'">
                <div class="mt-4 mb-4">
                    <label class="font-semibold block mb-2 text-blue-800">Judul Pemeriksaan Penunjang</label>
                    <div class="flex gap-2">
                        <p-select
                            class="w-1/2"
                            [options]="getExistingDetailNames()"
                            optionLabel="label"
                            optionValue="value"
                            [(ngModel)]="judulPemeriksaanPenunjang"
                            placeholder="Pilih nama yang sudah ada"
                            appendTo="body"
                            [showClear]="true"
                        ></p-select>
                        <input
                            pInputText
                            class="w-1/2 border border-blue-200 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-300"
                            [(ngModel)]="judulPemeriksaanPenunjang"
                            placeholder="Atau masukkan nama baru"
                        />
                    </div>
                </div>
                <div class="mt-4 mb-4">
                    <label class="font-semibold block mb-2 text-blue-800">Pilih OSCE untuk Detail Pemeriksaan</label>
                    <p-select
                        class="w-full"
                        [options]="osceList"
                        optionLabel="TITLE"
                        optionValue="ID_OSCE"
                        [(ngModel)]="selectedOsceForDetail"
                        placeholder="Pilih OSCE"
                        appendTo="body"
                        [filter]="true"
                        filterBy="TITLE"
                        [showClear]="true"
                        styleClass="border-blue-200"
                    ></p-select>
                </div>
                <div class="mt-4 mb-4">
                    <label class="font-semibold block mb-2 text-blue-800">Isi Pemeriksaan</label>
                    <p-editor [(ngModel)]="textDetailEditor" [style]="{height:'180px'}" styleClass="rounded border-blue-200"></p-editor>
                </div>
                <div class="flex justify-end mt-4">
                    <p-button label="Simpan" icon="pi pi-save" (click)="saveTextDetail()" styleClass="p-button-success" />
                </div>
            </ng-container>
            <div *ngIf="selectedPemeriksaanDetail.type !== 'table' && selectedPemeriksaanDetail.type !== 'text'" class="mt-4 text-gray-600 italic">
                <span>Tipe tidak dikenali</span>
            </div>
        </div>
        <div *ngIf="!selectedPemeriksaanDetail" class="flex flex-col items-center justify-center py-8 text-center text-blue-400">
            <i class="pi pi-info-circle text-4xl mb-2"></i>
            <span class="text-base font-medium">Silakan pilih pemeriksaan untuk melihat detail.</span>
        </div>
    </div>
</p-tabpanel>
                </p-tabpanels>
            </p-tabs>
        </div>

        <!-- Tambahkan dialog untuk daftar detail pemeriksaan -->
        <p-dialog header="Daftar Detail Pemeriksaan" [(visible)]="dialogSheetDetail" [modal]="true" [style]="{ width: '60vw' }" [draggable]="false" (onHide)="closeSheetDetailDialog()">
            <!-- Loading state -->
            <div *ngIf="dialogSheetDetailLoading" class="flex flex-col items-center justify-center py-12 text-center">
                <i class="pi pi-spin pi-spinner text-4xl text-blue-500 mb-4"></i>
                <span class="text-base font-medium text-gray-600">Memuat data detail pemeriksaan...</span>
            </div>
            
            <!-- Content when not loading -->
            <div *ngIf="!dialogSheetDetailLoading">
                <div *ngIf="groupedSheetDetails && groupedSheetDetailKeys().length > 0">
                    <!-- Search input -->
                    <div class="mb-4 flex items-center gap-2">
                        <input
                            pInputText
                            type="text"
                            placeholder="Cari detail pemeriksaan..."
                            class="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-primary-500"
                            [(ngModel)]="searchSheetDetail"
                            (ngModelChange)="applySearchSheetDetail()"
                        />
                    </div>
                    <p>Pilih maksimal 5 pemeriksaan penunjang yang memerlukan interpretasi</p>
                    <!-- Tampilkan pesan jika tidak ada hasil filter -->
                    <div *ngIf="isFilteredSheetDetailEmpty()" class="text-center text-gray-500 py-8">
                        Tidak ada detail pemeriksaan ditemukan untuk pencarian ini.
                    </div>
                    <!-- Loop group hanya jika hasil filter group tidak kosong -->
                    <div *ngFor="let group of groupedSheetDetailKeys()" class="mb-6" >
                        <ng-container *ngIf="filteredGroupedSheetDetails[group]?.length > 0">
                            <div class="font-bold text-blue-900 mb-2 flex items-center gap-2">
                                {{ group }}
                            </div>
                            <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                                <div *ngFor="let detail of filteredGroupedSheetDetails[group]" class="border border-blue-200 rounded-lg p-4 bg-blue-50 shadow flex flex-col gap-2">
                                    <div class="flex items-center gap-2">
                                        <p-checkbox
                                            [(ngModel)]="checkedSheetDetails[detail.id]"
                                            binary="true"
                                            (onChange)="onInterpretasiChange(detail, checkedSheetDetails[detail.id])"
                                        ></p-checkbox>
                                        <div class="flex flex-col gap-1">
                                            <div>
                                                <span class="font-semibold text-blue-800">{{ detail.name }}</span>
                                                <span class="text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded font-medium ml-2">
                                                    {{ detail.sheet_type === 'table' ? 'Tabel' : 'Teks Bebas' }}
                                                </span>
                                            </div>
                                            <p class="text-xs text-gray-500">{{ detail.osce_name }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
                <div *ngIf="!groupedSheetDetails || groupedSheetDetailKeys().length === 0" class="text-center text-gray-500 py-8">
                    <i class="pi pi-info-circle text-4xl mb-2"></i>
                    <span class="text-base font-medium">Tidak ada detail pemeriksaan.</span>
                    <span class="text-sm block mt-1">Silakan tambah detail pemeriksaan terlebih dahulu.</span>
                </div>
            </div>
        </p-dialog>

        <!-- Dialog untuk mapping detail pemeriksaan -->
        <p-dialog header="Mapping Detail Pemeriksaan" [(visible)]="dialogSheetDetailMapping" [modal]="true" [style]="{ width: '60vw' }" [draggable]="false" (onHide)="closeSheetDetailMappingDialog()">
            <!-- Loading state -->
            <div *ngIf="dialogSheetDetailMappingLoading" class="flex flex-col items-center justify-center py-12 text-center">
                <i class="pi pi-spin pi-spinner text-4xl text-orange-500 mb-4"></i>
                <span class="text-base font-medium text-gray-600">Memuat data detail pemeriksaan...</span>
            </div>
            
            <!-- Content when not loading -->
            <div *ngIf="!dialogSheetDetailMappingLoading">
                <div *ngIf="groupedSheetDetailsMapping && groupedSheetDetailMappingKeys().length > 0">
                    <!-- Search input -->
                    <div class="mb-4 flex items-center gap-2">
                        <input
                            pInputText
                            type="text"
                            placeholder="Cari detail pemeriksaan..."
                            class="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-orange-500"
                            [(ngModel)]="searchSheetDetailMapping"
                            (ngModelChange)="applySearchSheetDetailMapping()"
                        />
                    </div>
                    <p class="text-orange-700 font-medium">Pilih pemeriksaan yang ingin kamu tampilkan</p>
                    <!-- Tampilkan pesan jika tidak ada hasil filter -->
                    <div *ngIf="isFilteredSheetDetailMappingEmpty()" class="text-center text-gray-500 py-8">
                        Tidak ada detail pemeriksaan ditemukan untuk pencarian ini.
                    </div>
                    <!-- Loop group hanya jika hasil filter group tidak kosong -->
                    <div *ngFor="let group of groupedSheetDetailMappingKeys()" class="mb-6" >
                        <ng-container *ngIf="filteredGroupedSheetDetailsMapping[group]?.length > 0">
                            <div class="font-bold text-orange-900 mb-2 flex items-center gap-2">
                                {{ group }}
                            </div>
                            <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                                <div *ngFor="let detail of filteredGroupedSheetDetailsMapping[group]" class="border border-orange-200 rounded-lg p-4 bg-orange-50 shadow flex flex-col gap-2">
                                    <div class="flex items-center gap-2">
                                        <p-checkbox
                                            [(ngModel)]="checkedSheetDetailsMapping[detail.id]"
                                            binary="true"
                                            (onChange)="onMappingChange(detail, checkedSheetDetailsMapping[detail.id])"
                                        ></p-checkbox>
                                        <div class="flex flex-col gap-1">
                                            <div>
                                                <span class="font-semibold text-orange-800">
                                                    {{ detail.osce_name }}
                                                    <span *ngIf="detail.osce_name && detail.name"> | </span>
                                                    {{ detail.name }}
                                                </span>
                                            </div>
                                        </div>
                                        <div class="text-xs bg-orange-100 text-orange-700 px-2 py-1 rounded font-medium ml-2">
                                            {{ detail.sheet_type === 'table' ? 'Tabel' : 'Teks Bebas' }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
                <div *ngIf="!groupedSheetDetailsMapping || groupedSheetDetailMappingKeys().length === 0" class="text-center text-gray-500 py-8">
                    <i class="pi pi-info-circle text-4xl mb-2"></i>
                    <span class="text-base font-medium">Tidak ada detail pemeriksaan.</span>
                    <span class="text-sm block mt-1">Silakan tambah detail pemeriksaan terlebih dahulu.</span>
                </div>
            </div>
        </p-dialog>
    `,
    styles: [],
})
export class SheetCases implements OnInit {
    // Fungsi untuk grouping detail berdasarkan sheet_name dan name
    getDetailsBySheetNameAndDetailName(sheetName: string, detailName: string): any[] {
        const details = this.filteredGroupedSheetDetailsBySheetName[sheetName] || [];
        return details.filter((d: any) => d.name === detailName);
    }

    // Mendapatkan daftar nama detail pemeriksaan yang sudah ada
    public getExistingDetailNames(): { label: string, value: string }[] {
        const names = new Set<string>();
        for (const sheetName of Object.keys(this.filteredGroupedSheetDetailsBySheetName)) {
            for (const detail of this.filteredGroupedSheetDetailsBySheetName[sheetName]) {
                if (detail.name) names.add(detail.name);
            }
        }
        return Array.from(names).map(n => ({ label: n, value: n }));
    }
    dialogCases: boolean = false;
    decription: string = '';
    judul: string = '';
    durasi: number = 0;
    is_active: boolean = true;
    cases: any[] = [];
    filteredCases: any[] = [];
    searchText: string = '';
    editMode: boolean = false;
    editingCaseId: number | null = null;
    dialogPemeriksaan: boolean = false;
    pemeriksaanText: string = '';
    pemeriksaanType: string = '';
    typeOptions = [
        { label: 'Teks Bebas', value: 'text' },
        { label: 'Tabel', value: 'table' }
    ];
    tableHeaders: string[] = [];
    newHeader: string = '';
    pemeriksaan : any;
    filteredPemeriksaan: any[] = [];
    searchPemeriksaan: string = '';
    editingPemeriksaanId: number | null = null;
    selectedPemeriksaanId: number | null = null;
    selectedPemeriksaanDetail: any = null;
    tableDetailEditors: string[] = [];
    judulPemeriksaanPenunjang: string = '';
    selectedOsceForDetail: number | null = null;
    textDetailEditor: string = '';
    sheetDetailsList: any[] = [];
    filteredSheetDetailsList: any[] = [];
    groupedSheetDetailsByOsce: { [osceName: string]: any[] } = {};
    filteredGroupedSheetDetailsByOsce: { [osceName: string]: any[] } = {};
    groupedSheetDetailsByPemeriksaan: { [pemeriksaanName: string]: any[] } = {};
    filteredGroupedSheetDetailsByPemeriksaan: { [pemeriksaanName: string]: any[] } = {};
    searchSheetDetailsList: string = '';
    dialogSheetDetail: boolean = false;
    dialogSheetDetailLoading: boolean = false;
    dialogSheetDetailMapping: boolean = false;
    dialogSheetDetailMappingLoading: boolean = false;
    groupedSheetDetails: { [sheetName: string]: any[] } = {};
    groupedSheetDetailsMapping: { [sheetName: string]: any[] } = {};
    checkedSheetDetails: { [id: string]: boolean } = {};
    checkedSheetDetailsMapping: { [id: string]: boolean } = {};
    searchSheetDetail: string = '';
    searchSheetDetailMapping: string = '';
    filteredGroupedSheetDetails: { [sheetName: string]: any[] } = {};
    filteredGroupedSheetDetailsMapping: { [sheetName: string]: any[] } = {};
    // Grouping sheet_name -> name -> osce_name
    groupedSheetDetailsBySheetName: { [sheetName: string]: any[] } = {};
    filteredGroupedSheetDetailsBySheetName: { [sheetName: string]: any[] } = {};

    getSheetNameGroupKeys(): string[] {
        return Object.keys(this.filteredGroupedSheetDetailsBySheetName || {});
    }

    getDetailNameGroupKeysForSheet(sheetName: string): string[] {
        const details = this.filteredGroupedSheetDetailsBySheetName[sheetName] || [];
        return Array.from(new Set(details.map((d: any) => d.name)));
    }

    getOsceGroupKeysForSheetAndDetailName(sheetName: string, detailName: string): string[] {
        const details = (this.filteredGroupedSheetDetailsBySheetName[sheetName] || []).filter((d: any) => d.name === detailName);
        return Array.from(new Set(details.map((d: any) => d.osce_name)));
    }

    getDetailsBySheetNameDetailNameAndOsce(sheetName: string, detailName: string, osceName: string): any[] {
        return (this.filteredGroupedSheetDetailsBySheetName[sheetName] || []).filter((d: any) => d.name === detailName && d.osce_name === osceName);
    }

    // Grouping dan search
    groupAndFilterSheetDetails() {
        this.groupedSheetDetailsBySheetName = {};
        const keyword = (this.searchSheetDetailsList || '').toLowerCase();
        for (const detail of this.sheetDetailsList) {
            const sheetName = detail.sheet_name || 'Sheet Lain';
            if (!this.groupedSheetDetailsBySheetName[sheetName]) {
                this.groupedSheetDetailsBySheetName[sheetName] = [];
            }
            if (!keyword ||
                (detail.name && detail.name.toLowerCase().includes(keyword)) ||
                (detail.sheet_name && detail.sheet_name.toLowerCase().includes(keyword)) ||
                (detail.osce_name && detail.osce_name.toLowerCase().includes(keyword))
            ) {
                this.groupedSheetDetailsBySheetName[sheetName].push(detail);
            }
        }
        // Remove empty groups
        this.filteredGroupedSheetDetailsBySheetName = {};
        for (const sheetName of Object.keys(this.groupedSheetDetailsBySheetName)) {
            if (this.groupedSheetDetailsBySheetName[sheetName].length > 0) {
                this.filteredGroupedSheetDetailsBySheetName[sheetName] = this.groupedSheetDetailsBySheetName[sheetName];
            }
        }
    }

    applySearchSheetDetailsList() {
        this.groupAndFilterSheetDetails();
    }
    editingSheetDetailId: string | null = null;
    dialogOsce: boolean = false;
    osceList: any[] = [];
    selectedOsceId: number | null = null;
    currentPemeriksaanForOsce: any = null;
    dialogSelectPemeriksaan: boolean = false;
    selectedPemeriksaanIdForDetail: number | null = null;

    constructor(
        private userService: UserService,
        public messageService: MessageService,
        private confirmationService: ConfirmationService
    ) {}

    ngOnInit() {
        this.initApi();
        this.loadOsceData();
    }

    initApi(){
        this.userService.getSheetCases(null).then((res) => {
            this.cases = res.data || [];
            this.applySearchSort();
        }).catch(() => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Gagal mengambil data kasus' });
        });
        this.userService.getSheet(null).then((res) => {
            this.pemeriksaan = res.data || [];
            this.applySearchPemeriksaan();
        }).catch(() => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Gagal mengambil data pemeriksaan' });
        });
        // Load juga semua detail pemeriksaan untuk pengelompokan
        this.fetchAllSheetDetails();
    }

    loadOsceData() {
        this.userService.getOsce().then((res) => {
            this.osceList = res.data || [];
        }).catch(() => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Gagal mengambil data OSCE' });
        });
    }

    applySearchSort() {
        let filtered = this.cases.filter(item =>
            (!this.searchText ||
                (item.name && item.name.toLowerCase().includes(this.searchText.toLowerCase())) ||
                (item.description && item.description.toLowerCase().includes(this.searchText.toLowerCase()))
            )
        );
        filtered = filtered.sort((a, b) => {
            const dateA = new Date(a.created_at).getTime();
            const dateB = new Date(b.created_at).getTime();
            return dateB - dateA;
        });
        this.filteredCases = filtered;
    }

    applySearchPemeriksaan() {
        if (!this.pemeriksaan) {
            this.filteredPemeriksaan = [];
            return;
        }
        const keyword = (this.searchPemeriksaan || '').toLowerCase();
        this.filteredPemeriksaan = this.pemeriksaan.filter((item: any) =>
            !keyword ||
            (item.name && item.name.toLowerCase().includes(keyword))
        );
    }

    openDialogCases() {
        this.dialogCases = true;
        this.editMode = false;
        this.editingCaseId = null;
        this.judul = '';
        this.decription = '';
        this.durasi = 0;
        this.is_active = true;
    }
    closeDialogCases() {
        this.dialogCases = false;
        this.editMode = false;
        this.editingCaseId = null;
        this.judul = '';
        this.decription = '';
        this.durasi = 0;
        this.is_active = true;
    }
    saveCases() {
        this.userService.addSheetCases({
            name: this.judul,
            description: this.decription,
            timer: this.durasi,
            is_active: this.is_active ? 1 : 0
        }).then(() => {
            this.dialogCases = false;
            this.judul = '';
            this.decription = '';
            this.durasi = 0;
            this.is_active = true;
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Kasus berhasil disimpan' });
        }).catch(() => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Gagal menyimpan kasus' });
        });
    }
    editCase(item: any) {
        this.dialogCases = true;
        this.editMode = true;
        this.editingCaseId = item.id;
        this.judul = item.name;
        this.decription = item.description;
        this.durasi = item.timer;
        this.is_active = item.is_active == 1;
    }
    updateCases() {
        if (!this.editingCaseId) return;
        this.userService.updateSheetCases({
            id: this.editingCaseId,
            name: this.judul,
            description: this.decription,
            timer: this.durasi,
            is_active: this.is_active ? 1 : 0
        }).then(() => {
            this.dialogCases = false;
            this.editMode = false;
            this.editingCaseId = null;
            this.judul = '';
            this.decription = '';
            this.durasi = 0;
            this.is_active = true;
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Kasus berhasil diupdate' });
        }).catch(() => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Gagal mengupdate kasus' });
        });
    }

    deleteCase(item: any) {
        this.confirmationService.confirm({
            target: event?.target as EventTarget,
            message: 'Apakah Anda yakin ingin menghapus kasus ini?',
            header: 'Konfirmasi Hapus',
            closable: true,
            closeOnEscape: true,
            icon: 'pi pi-exclamation-triangle',
            rejectButtonProps: {
                label: 'Batal',
                severity: 'secondary',
                outlined: true,
            },
            acceptButtonProps: {
                label: 'Hapus',
                severity: 'danger',
                outlined: true,
            },
            accept: () => {
                this.userService.deleteSheetCases({ id: item.id }).then(() => {
                    this.messageService.add({ severity: 'success', summary: 'Berhasil', detail: 'Kasus berhasil dihapus' });
                    this.initApi();
                }).catch(() => {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Gagal menghapus kasus' });
                });
            }
        });
    }

    openDialogPemeriksaan() {
        this.dialogPemeriksaan = true;
        this.editingPemeriksaanId = null;
        this.pemeriksaanText = '';
        this.pemeriksaanType = '';
        this.tableHeaders = [];
        this.newHeader = '';
    }
    closeDialogPemeriksaan() {
        this.dialogPemeriksaan = false;
        this.pemeriksaanText = '';
        this.pemeriksaanType = '';
        this.tableHeaders = [];
        this.newHeader = '';
    }
    addHeader() {
        setTimeout(() => {
            const header = (this.newHeader ?? '').trim();
            if (header.length > 0) {
                this.tableHeaders.push(header);
                this.newHeader = '';
            }
        });
    }
    removeHeader(idx: number) {
        this.tableHeaders.splice(idx, 1);
    }
    editPemeriksaan(item: any) {
        this.dialogPemeriksaan = true;
        this.editingPemeriksaanId = item.id;
        setTimeout(() => {
            this.pemeriksaanText = item.name;
            this.pemeriksaanType = item.type;
            if (item.type === 'table' && item.header) {
                try {
                    this.tableHeaders = JSON.parse(item.header);
                } catch {
                    this.tableHeaders = [];
                }
            } else {
                this.tableHeaders = [];
            }
            this.newHeader = '';
        }, 0);
    }

    deletePemeriksaan(item: any) {
        this.confirmationService.confirm({
            message: 'Apakah Anda yakin ingin menghapus pemeriksaan ini?',
            header: 'Konfirmasi Hapus',
            icon: 'pi pi-exclamation-triangle',
            acceptButtonProps: {
                label: 'Hapus',
                severity: 'danger',
                outlined: true,
            },
            rejectButtonProps: {
                label: 'Batal',
                severity: 'secondary',
                outlined: true,
            },
            accept: () => {
                this.userService.deleteSheet({ id: item.id }).then(() => {
                    this.messageService.add({ severity: 'success', summary: 'Berhasil', detail: 'Pemeriksaan berhasil dihapus' });
                    this.initApi();
                    this.applySearchPemeriksaan();
                }).catch(() => {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Gagal menghapus pemeriksaan' });
                });
            }
        });
    }

    savePemeriksaan() {
        const payload = {
            id: this.editingPemeriksaanId,
            name: this.pemeriksaanText,
            type: this.pemeriksaanType,
            header: this.pemeriksaanType === 'table' && this.tableHeaders.length > 0
                ? JSON.stringify(this.tableHeaders)
                : null,
        };
        const savePromise = this.editingPemeriksaanId
            ? this.userService.updateSheet(payload)
            : this.userService.addSheet(payload);

        savePromise.then(() => {
            this.initApi();
            this.pemeriksaanText = '';
            this.pemeriksaanType = '';
            this.tableHeaders = [];
            this.newHeader = '';
            this.dialogPemeriksaan = false;
            this.editingPemeriksaanId = null;
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Pemeriksaan berhasil disimpan' });
            this.applySearchPemeriksaan();
        }).catch(() => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Gagal menyimpan pemeriksaan' });
        });
    }

    onSelectPemeriksaan() {
        if (!this.selectedPemeriksaanId) {
            this.selectedPemeriksaanDetail = null;
            this.tableDetailEditors = [];
            this.textDetailEditor = '';
            this.judulPemeriksaanPenunjang = '';
            this.selectedOsceForDetail = null;
            return;
        }
        
        // Cari pemeriksaan dari daftar yang sudah difilter
        const found = this.filteredPemeriksaan.find((item: any) => item.id == this.selectedPemeriksaanId);
        
        if (!found) {
            this.messageService.add({ 
                severity: 'warn', 
                summary: 'Peringatan', 
                detail: 'Pemeriksaan tidak ditemukan' 
            });
            return;
        }

        this.selectedPemeriksaanDetail = found;
        
        // Reset form fields
        this.judulPemeriksaanPenunjang = '';
        this.selectedOsceForDetail = null;
        this.editingSheetDetailId = null;
        
        if (this.selectedPemeriksaanDetail.type === 'table' && this.selectedPemeriksaanDetail.header) {
            try {
                const headers = JSON.parse(this.selectedPemeriksaanDetail.header);
                this.tableDetailEditors = headers.map(() => '');
            } catch {
                this.tableDetailEditors = [];
            }
        } else {
            this.tableDetailEditors = [];
        }
        
        if (this.selectedPemeriksaanDetail.type === 'text') {
            this.textDetailEditor = '';
        }
        
        // Scroll ke form detail pemeriksaan
        setTimeout(() => {
            const element = document.querySelector('[data-form="detail-pemeriksaan"]');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }, 100);
    }

    onUpdateSheetDetail(detail: any) {
        this.selectedPemeriksaanDetail = {
            id: detail.sheet_id,
            name: detail.sheet_name,
            type: detail.sheet_type,
            header: detail.header
        };
        this.selectedPemeriksaanId = detail.sheet_id;
        this.selectedOsceForDetail = detail.osce_id || null; // Set OSCE yang sudah dipilih sebelumnya
        if (detail.sheet_type === 'table') {
            try {
                const headers = JSON.parse(detail.header || '[]');
                this.tableDetailEditors = [];
                if (detail.content) {
                    const contentArr = JSON.parse(detail.content);
                    this.tableDetailEditors = headers.map((_: string, idx: number) => contentArr[idx] || '');
                } else {
                    this.tableDetailEditors = headers.map(() => '');
                }
                this.judulPemeriksaanPenunjang = detail.name || '';
            } catch {
                this.tableDetailEditors = [];
                this.judulPemeriksaanPenunjang = detail.name || '';
            }
        }
        else if (detail.sheet_type === 'text') {
            this.textDetailEditor = detail.content || '';
            this.judulPemeriksaanPenunjang = detail.name || '';
        }
        this.editingSheetDetailId = detail.id;
    }

    saveTableDetail() {
        if (!this.selectedPemeriksaanDetail) return;
        const payload: any = {
            name: this.judulPemeriksaanPenunjang,
            sheet_id: this.selectedPemeriksaanDetail.id,
            content: JSON.stringify(this.tableDetailEditors),
            osce_id: this.selectedOsceForDetail // Tambahkan OSCE ID yang dipilih
        };
        if (this.editingSheetDetailId) {
            payload.id = this.editingSheetDetailId;
            this.userService.updateSheetDetails(payload).then(() => {
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Detail berhasil diupdate' });
                this.editingSheetDetailId = null;
                this.closeDetailForm();
                this.fetchAllSheetDetails();
            }).catch(() => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Gagal update detail' });
            });
        } else {
            this.userService.addSheetDetails(payload).then(() => {
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Pemeriksaan berhasil disimpan' });
                this.closeDetailForm();
                this.fetchAllSheetDetails();
            }).catch(() => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Gagal menyimpan pemeriksaan' });
            });
        }
    }

    saveTextDetail() {
        if (!this.selectedPemeriksaanDetail) return;
        const payload: any = {
            name: this.judulPemeriksaanPenunjang,
            sheet_id: this.selectedPemeriksaanDetail.id,
            content: this.textDetailEditor,
            osce_id: this.selectedOsceForDetail // Tambahkan OSCE ID yang dipilih
        };
        if (this.editingSheetDetailId) {
            payload.id = this.editingSheetDetailId;
            this.userService.updateSheetDetails(payload).then(() => {
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Detail berhasil diupdate' });
                this.editingSheetDetailId = null;
                this.closeDetailForm();
                this.fetchAllSheetDetails();
            }).catch(() => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Gagal update detail' });
            });
        } else {
            this.userService.addSheetDetails(payload).then(() => {
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Pemeriksaan berhasil disimpan' });
                this.closeDetailForm();
                this.fetchAllSheetDetails();
            }).catch(() => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Gagal menyimpan pemeriksaan' });
            });
        }
    }

    fetchSheetDetails() {
        if (!this.selectedPemeriksaanId) {
            this.sheetDetailsList = [];
            this.filteredSheetDetailsList = [];
            this.groupedSheetDetailsByOsce = {};
            this.filteredGroupedSheetDetailsByOsce = {};
            this.groupedSheetDetailsByPemeriksaan = {};
            this.filteredGroupedSheetDetailsByPemeriksaan = {};
            this.messageService.add({ severity: 'warn', summary: 'Pilih Pemeriksaan', detail: 'Silakan pilih pemeriksaan terlebih dahulu.' });
            return;
        }
        this.userService.getSheetDetails({ sheet_id: this.selectedPemeriksaanId }).then(res => {
            this.sheetDetailsList = res.data || [];
            this.applySearchSheetDetailsList();
            if (!this.sheetDetailsList.length) {
                this.messageService.add({ severity: 'info', summary: 'Tidak ada data', detail: 'Belum ada detail pemeriksaan.' });
            }
        }).catch(() => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Gagal mengambil daftar detail pemeriksaan' });
        });
    }

    fetchAllSheetDetails() {
        // Load semua detail pemeriksaan tanpa filter sheet_id
        this.userService.getSheetDetails(null).then(res => {
            this.sheetDetailsList = res.data || [];
            this.applySearchSheetDetailsList(); // Sudah otomatis grouping baru
        }).catch(() => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Gagal mengambil daftar detail pemeriksaan' });
        });
    }

    onDeleteSheetDetail(detail: any) {
        this.confirmationService.confirm({
            message: `Apakah Anda yakin ingin menghapus detail "${detail.name}"?`,
            header: 'Konfirmasi Hapus',
            icon: 'pi pi-exclamation-triangle',
            acceptButtonProps: {
                label: 'Hapus',
                severity: 'danger',
                outlined: true,
            },
            rejectButtonProps: {
                label: 'Batal',
                severity: 'secondary',
                outlined: true,
            },
            accept: () => {
                this.userService.deleteSheetDetails({ id: detail.id }).then(() => {
                    this.messageService.add({ severity: 'success', summary: 'Berhasil', detail: 'Detail pemeriksaan berhasil dihapus' });
                    this.fetchAllSheetDetails();
                }).catch(() => {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Gagal menghapus detail pemeriksaan' });
                });
            }
        });
    }

    closeDetailForm() {
        this.tableDetailEditors = [];
        this.textDetailEditor = '';
        this.judulPemeriksaanPenunjang = '';
        this.selectedOsceForDetail = null;
        this.editingSheetDetailId = null;
    }

    showSheetDetail(item: any) {
        this.selectedPemeriksaanId = item.id;
        this.dialogSheetDetail = true;
        this.dialogSheetDetailLoading = true; // Set loading state to true
        
        this.userService.getSheetDetails(null).then(res => {
            const data = res.data || [];
            this.groupedSheetDetails = {};
            data.forEach((detail: any) => {
                if (!this.groupedSheetDetails[detail.sheet_name]) {
                    this.groupedSheetDetails[detail.sheet_name] = [];
                }
                this.groupedSheetDetails[detail.sheet_name].push(detail);
            });
            this.checkedSheetDetails = {};
            if (item.pivot && Array.isArray(item.pivot)) {
                item.pivot.forEach((p: any) => {
                    if (p.sheet_detail_id && p.interpretasi == "1") {
                        this.checkedSheetDetails[p.sheet_detail_id] = true;
                    }
                });
            }
            this.searchSheetDetail = '';
            this.applySearchSheetDetail();
        }).catch(() => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Gagal mengambil daftar detail pemeriksaan' });
        }).finally(() => {
            this.dialogSheetDetailLoading = false; // Set loading state to false when done
        });
    }

    showSheetDetailMapping(item: any) {
        this.selectedPemeriksaanId = item.id;
        this.dialogSheetDetailMapping = true;
        this.dialogSheetDetailMappingLoading = true; // Set loading state to true
        
        this.userService.getSheetDetails(null).then(res => {
            const data = res.data || [];
            this.groupedSheetDetailsMapping = {};
            data.forEach((detail: any) => {
                if (!this.groupedSheetDetailsMapping[detail.sheet_name]) {
                    this.groupedSheetDetailsMapping[detail.sheet_name] = [];
                }
                this.groupedSheetDetailsMapping[detail.sheet_name].push(detail);
            });
            
            // Set checkbox state based on pivot data for this case, checked if in pivot regardless of interpretasi
            this.checkedSheetDetailsMapping = {};
            if (item.pivot && Array.isArray(item.pivot)) {
                item.pivot.forEach((p: any) => {
                    if (p.sheet_detail_id) {
                        this.checkedSheetDetailsMapping[p.sheet_detail_id] = true;
                    }
                });
            }
            
            this.searchSheetDetailMapping = '';
            this.applySearchSheetDetailMapping();
        }).catch(() => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Gagal mengambil daftar detail pemeriksaan' });
        }).finally(() => {
            this.dialogSheetDetailMappingLoading = false; // Set loading state to false when done
        });
    }

    applySearchSheetDetail() {
        const keyword = (this.searchSheetDetail || '').toLowerCase();
        this.filteredGroupedSheetDetails = {};
        for (const group of this.groupedSheetDetailKeys()) {
            this.filteredGroupedSheetDetails[group] = (this.groupedSheetDetails[group] || []).filter((detail: any) =>
                !keyword ||
                (detail.name && detail.name.toLowerCase().includes(keyword))
            );
        }
    }

    groupedSheetDetailKeys() {
        return this.groupedSheetDetails ? Object.keys(this.groupedSheetDetails) : [];
    }

    closeSheetDetailDialog() {
        this.dialogSheetDetail = false;
        this.dialogSheetDetailLoading = false; // Reset loading state
        this.sheetDetailsList = [];
        this.groupedSheetDetails = {};
        this.filteredGroupedSheetDetails = {};
        this.checkedSheetDetails = {};
        this.searchSheetDetail = '';
    }

    closeSheetDetailMappingDialog() {
        this.dialogSheetDetailMapping = false;
        this.dialogSheetDetailMappingLoading = false; // Reset loading state
        this.groupedSheetDetailsMapping = {};
        this.filteredGroupedSheetDetailsMapping = {};
        this.checkedSheetDetailsMapping = {};
        this.searchSheetDetailMapping = '';
    }

    applySearchSheetDetailMapping() {
        const keyword = (this.searchSheetDetailMapping || '').toLowerCase();
        this.filteredGroupedSheetDetailsMapping = {};
        for (const group of this.groupedSheetDetailMappingKeys()) {
            this.filteredGroupedSheetDetailsMapping[group] = (this.groupedSheetDetailsMapping[group] || []).filter((detail: any) =>
                !keyword ||
                (detail.name && detail.name.toLowerCase().includes(keyword))
            );
        }
    }

    groupedSheetDetailMappingKeys() {
        return this.groupedSheetDetailsMapping ? Object.keys(this.groupedSheetDetailsMapping) : [];
    }

    isFilteredSheetDetailMappingEmpty(): boolean {
        if (!this.filteredGroupedSheetDetailsMapping) return true;
        return this.groupedSheetDetailMappingKeys().every(
            group => !this.filteredGroupedSheetDetailsMapping[group] || this.filteredGroupedSheetDetailsMapping[group].length === 0
        );
    }

    onMappingChange(detail: any, checked: boolean) {
        const sheet_case_id = this.selectedPemeriksaanId;
        const sheet_detail_id = detail.id;
        if (!sheet_case_id || !sheet_detail_id) return;

        if (checked) {
            this.userService.attachSheetPivot({
                sheet_detail_id,
                sheet_case_id
            }).then(() => {
                this.refreshSheetCases();
            }).catch(() => {
                // Revert checkbox on error
                this.checkedSheetDetailsMapping[detail.id] = false;
                this.messageService.add({ 
                    severity: 'error', 
                    summary: 'Error', 
                    detail: 'Gagal menambahkan mapping'
                });
            });
        } else {
            this.userService.detachSheetPivot({
                sheet_detail_id,
                sheet_case_id
            }).then(() => {
                this.refreshSheetCases();
            }).catch(() => {
                // Revert checkbox on error
                this.checkedSheetDetailsMapping[detail.id] = true;
                this.messageService.add({ 
                    severity: 'error', 
                    summary: 'Error', 
                    detail: 'Gagal menghapus mapping'
                });
            });
        }
    }

    isFilteredSheetDetailEmpty(): boolean {
        if (!this.filteredGroupedSheetDetails) return true;
        return this.groupedSheetDetailKeys().every(
            group => !this.filteredGroupedSheetDetails[group] || this.filteredGroupedSheetDetails[group].length === 0
        );
    }

    onInterpretasiChange(detail: any, checked: boolean) {
        const sheet_case_id = this.selectedPemeriksaanId;
        const sheet_detail_id = detail.id;
        const interpretasi = 1;
        if (!sheet_case_id || !sheet_detail_id) return;

        if (checked) {
            this.userService.attachSheetPivot({
                sheet_detail_id,
                sheet_case_id,
                interpretasi
            }).then(() => {
                this.refreshSheetCases();
            });
        } else {
            this.userService.detachSheetPivot({
                sheet_detail_id,
                sheet_case_id
            }).then(() => {
                this.refreshSheetCases();
            });
        }
    }

    refreshSheetCases() {
        this.userService.getSheetCases(null).then((res) => {
            this.cases = res.data || [];
            this.applySearchSort();
        });
    }

    openOsceDialog(detailPemeriksaan: any) {
        this.currentPemeriksaanForOsce = detailPemeriksaan;
        this.selectedOsceId = null;
        this.dialogOsce = true;
    }

    closeDialogOsce() {
        this.dialogOsce = false;
        this.currentPemeriksaanForOsce = null;
        this.selectedOsceId = null;
    }

    addPemeriksaanToOsce() {
        if (!this.selectedOsceId || !this.currentPemeriksaanForOsce) {
            this.messageService.add({ severity: 'warn', summary: 'Peringatan', detail: 'Silakan pilih OSCE terlebih dahulu' });
            return;
        }

        // Find the selected OSCE name for display
        const selectedOsce = this.osceList.find(osce => osce.ID_OSCE === this.selectedOsceId);
        const osceName = selectedOsce ? selectedOsce.TITLE : 'OSCE';

        const updateData = {
            id: this.currentPemeriksaanForOsce.id, // detail pemeriksaan ID
            osce_id: this.selectedOsceId
        };

        // Call updateFormDetails service
        this.userService.updateSheetDetails(updateData).then(() => {
            this.messageService.add({ 
                severity: 'success', 
                summary: 'Berhasil', 
                detail: `Detail Pemeriksaan "${this.currentPemeriksaanForOsce.name}" berhasil ditambahkan ke ${osceName}` 
            });
            this.closeDialogOsce();
            // Refresh the sheet details list to show the updated OSCE badge
            this.fetchAllSheetDetails();
        }).catch(() => {
            this.messageService.add({ 
                severity: 'error', 
                summary: 'Error', 
                detail: 'Gagal menambahkan detail pemeriksaan ke OSCE' 
            });
        });
    }

    // Fungsi baru untuk membuka dialog pemilihan pemeriksaan
    openDialogSelectPemeriksaan() {
        this.dialogSelectPemeriksaan = true;
        this.selectedPemeriksaanIdForDetail = null;
    }

    closeDialogSelectPemeriksaan() {
        this.dialogSelectPemeriksaan = false;
        this.selectedPemeriksaanIdForDetail = null;
    }

    selectPemeriksaanForDetail() {
        if (!this.selectedPemeriksaanIdForDetail) {
            this.messageService.add({ severity: 'warn', summary: 'Peringatan', detail: 'Pilih pemeriksaan terlebih dahulu' });
            return;
        }

        // Set pemeriksaan yang dipilih sebagai detail
        this.selectedPemeriksaanId = this.selectedPemeriksaanIdForDetail;
        this.onSelectPemeriksaan();
        this.closeDialogSelectPemeriksaan();
    }

    // applySearchSheetDetailsList() {
    //     if (!this.sheetDetailsList) {
    //         this.filteredSheetDetailsList = [];
    //         this.groupedSheetDetailsByOsce = {};
    //         this.filteredGroupedSheetDetailsByOsce = {};
    //         this.groupedSheetDetailsByPemeriksaan = {};
    //         this.filteredGroupedSheetDetailsByPemeriksaan = {};
    //         return;
    //     }
    //     const keyword = (this.searchSheetDetailsList || '').toLowerCase();
    //     this.filteredSheetDetailsList = this.sheetDetailsList.filter((detail: any) =>
    //         !keyword ||
    //         (detail.name && detail.name.toLowerCase().includes(keyword)) ||
    //         (detail.osce_name && detail.osce_name.toLowerCase().includes(keyword)) ||
    //         (detail.sheet_type && detail.sheet_type.toLowerCase().includes(keyword)) ||
    //         (detail.sheet_name && detail.sheet_name.toLowerCase().includes(keyword))
    //     );

    //     // Group by OSCE name
    //     this.groupedSheetDetailsByOsce = {};
    //     this.sheetDetailsList.forEach((detail: any) => {
    //         const osceName = detail.osce_name || 'Belum Dikategorikan';
    //         if (!this.groupedSheetDetailsByOsce[osceName]) {
    //             this.groupedSheetDetailsByOsce[osceName] = [];
    //         }
    //         this.groupedSheetDetailsByOsce[osceName].push(detail);
    //     });

    //     // Group by Pemeriksaan name (LABORATORIUM, RADIOLOGI, etc.)
    //     this.groupedSheetDetailsByPemeriksaan = {};
    //     this.sheetDetailsList.forEach((detail: any) => {
    //         const pemeriksaanName = detail.sheet_name || 'Pemeriksaan Lain';
    //         if (!this.groupedSheetDetailsByPemeriksaan[pemeriksaanName]) {
    //             this.groupedSheetDetailsByPemeriksaan[pemeriksaanName] = [];
    //         }
    //         this.groupedSheetDetailsByPemeriksaan[pemeriksaanName].push(detail);
    //     });

    //     // Apply search filter to OSCE grouped data
    //     this.filteredGroupedSheetDetailsByOsce = {};
    //     Object.keys(this.groupedSheetDetailsByOsce).forEach(osceName => {
    //         this.filteredGroupedSheetDetailsByOsce[osceName] = this.groupedSheetDetailsByOsce[osceName].filter((detail: any) =>
    //             !keyword ||
    //             (detail.name && detail.name.toLowerCase().includes(keyword)) ||
    //             (detail.osce_name && detail.osce_name.toLowerCase().includes(keyword)) ||
    //             (detail.sheet_type && detail.sheet_type.toLowerCase().includes(keyword)) ||
    //             (detail.sheet_name && detail.sheet_name.toLowerCase().includes(keyword))
    //         );
    //     });

    //     // Apply search filter to Pemeriksaan grouped data
    //     this.filteredGroupedSheetDetailsByPemeriksaan = {};
    //     Object.keys(this.groupedSheetDetailsByPemeriksaan).forEach(pemeriksaanName => {
    //         this.filteredGroupedSheetDetailsByPemeriksaan[pemeriksaanName] = this.groupedSheetDetailsByPemeriksaan[pemeriksaanName].filter((detail: any) =>
    //             !keyword ||
    //             (detail.name && detail.name.toLowerCase().includes(keyword)) ||
    //             (detail.osce_name && detail.osce_name.toLowerCase().includes(keyword)) ||
    //             (detail.sheet_type && detail.sheet_type.toLowerCase().includes(keyword)) ||
    //             (detail.sheet_name && detail.sheet_name.toLowerCase().includes(keyword))
    //         );
    //     });
    // }

    getOsceGroupKeys(): string[] {
        return Object.keys(this.filteredGroupedSheetDetailsByOsce || {}).sort((a, b) => {
            // Put "Belum Dikategorikan" at the end
            if (a === 'Belum Dikategorikan') return 1;
            if (b === 'Belum Dikategorikan') return -1;
            return a.localeCompare(b);
        });
    }

    getPemeriksaanGroupKeys(): string[] {
        return Object.keys(this.filteredGroupedSheetDetailsByPemeriksaan || {}).sort((a, b) => {
            // Put "Pemeriksaan Lain" at the end
            if (a === 'Pemeriksaan Lain') return 1;
            if (b === 'Pemeriksaan Lain') return -1;
            return a.localeCompare(b);
        });
    }

    getPemeriksaanGroupKeysForOsce(osceName: string): string[] {
        const detailsInOsce = this.filteredGroupedSheetDetailsByOsce[osceName] || [];
        const pemeriksaanNames = new Set<string>();
        
        detailsInOsce.forEach(detail => {
            pemeriksaanNames.add(detail.sheet_name || 'Pemeriksaan Lain');
        });
        
        return Array.from(pemeriksaanNames).sort((a, b) => {
            if (a === 'Pemeriksaan Lain') return 1;
            if (b === 'Pemeriksaan Lain') return -1;
            return a.localeCompare(b);
        });
    }

    getOsceGroupKeysForPemeriksaan(pemeriksaanName: string): string[] {
        const detailsInPemeriksaan = this.filteredGroupedSheetDetailsByPemeriksaan[pemeriksaanName] || [];
        const osceNames = new Set<string>();
        
        detailsInPemeriksaan.forEach(detail => {
            osceNames.add(detail.osce_name || 'Belum Dikategorikan');
        });
        
        return Array.from(osceNames).sort((a, b) => {
            if (a === 'Belum Dikategorikan') return 1;
            if (b === 'Belum Dikategorikan') return -1;
            return a.localeCompare(b);
        });
    }

    getDetailsByOsceAndPemeriksaan(osceName: string, pemeriksaanName: string): any[] {
        const detailsInOsce = this.filteredGroupedSheetDetailsByOsce[osceName] || [];
        return detailsInOsce.filter(detail => 
            (detail.sheet_name || 'Pemeriksaan Lain') === pemeriksaanName
        );
    }

    getDetailsByPemeriksaanAndOsce(pemeriksaanName: string, osceName: string): any[] {
        const detailsInPemeriksaan = this.filteredGroupedSheetDetailsByPemeriksaan[pemeriksaanName] || [];
        return detailsInPemeriksaan.filter(detail => 
            (detail.osce_name || 'Belum Dikategorikan') === osceName
        );
    }

    onFileSelected(event: any) {
        const file = event.files[0];
        if (file) {
            console.log('File selected:', file);
            // Tambahkan logika upload file di sini
        }
    }

    onFileSelectedForDetail(event: any, detail: any) {
        const file = event.files[0];
        if (file) {
            this.convertFileToBase64(file).then(base64 => {
                const updateData = {
                    id: detail.id,
                    icon: base64
                };
                this.userService.updateSheetDetails(updateData).then(() => {
                    this.messageService.add({severity: 'success', summary: 'Berhasil', detail: 'Icon berhasil diupdate'});
                    this.fetchAllSheetDetails(); // Refresh data
                }).catch(() => {
                    this.messageService.add({severity: 'error', summary: 'Error', detail: 'Gagal mengupdate icon'});
                });
            });
        }
    }

    convertFileToBase64(file: File): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result as string);
            reader.onerror = error => reject(error);
        });
    }
}